import { useContext, useMemo, useState } from "react";
import { useDeleteGroupTrainingMutation, useGetAllGroupsQuery, useInsertGroupTrainingMutation } from "../../slices/groupsApiSlice";
import GroupHandler from "./GroupHandler"
import dataApplicationsContext from "../../context/dataApplicationsContext";

const DAYS = [
  { value: 1, label: 'L' },
  { value: 2, label: 'M' },
  { value: 3, label: 'M' },
  { value: 4, label: 'J' },
  { value: 5, label: 'V' },
  { value: 6, label: 'S' },
  { value: 7, label: 'D' },
];

// Regroupe les exceptions par "semaine" (même date_from/date_to/label)
const groupExceptionsByWeek = (exceptions = []) => {
  const map = new Map();
  exceptions.forEach(exc => {
    const key = `${exc.date_from}_${exc.date_to}_${exc.label}`;
    if (!map.has(key)) {
      map.set(key, { date_from: exc.date_from, date_to: exc.date_to, label: exc.label, days: [] });
    }
    map.get(key).days.push(exc);
  });
  return Array.from(map.values());
};

const DayCheckboxRow = ({ variant, label, sublabel, getChecked, onToggle, libGroup }) => (
  <div className={`training-row training-row--${variant}`}>
		<div className="">
			<p className="group-card__title mb-0">{libGroup}</p>
			<div className="training-row__label">
				<p className="training-row__title">{label}</p>
				{sublabel && <div className="training-row__sub">{sublabel}</div>}
			</div>
		</div>
    <div className="training-row__days">
      {DAYS.map(day => (
        <label key={day.value} className="day-toggle">
          <span className="day-toggle__letter">{day.label}</span>
          <input
            className="day-toggle__input"
            type="checkbox"
            checked={getChecked(day.value)}
            onChange={(e) => onToggle?.(day.value, e.target.checked)}
            disabled={!onToggle}
          />
          <span className="day-toggle__pill" />
        </label>
      ))}
    </div>
  </div>
);

const SettingGroup = () => {
  const { selectedSeason } = useContext(dataApplicationsContext);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const { data: groups, isLoading: isLoadingGroups, isSuccess: isSuccessGroups } = useGetAllGroupsQuery(selectedSeason?.value, { skip: !selectedSeason });
	const [insertGroupTraining] = useInsertGroupTrainingMutation()
	const [deleteGroupTraining] = useDeleteGroupTrainingMutation()

  const optionGroups = useMemo(() => {
    if (!isSuccessGroups) return [];
    return groups.filter(g => g.id_group !== 20).map(group => ({ label: group.lib_group, value: group.id_group }));
  }, [isSuccessGroups, groups])

  const handleToggleGeneral = async (id_group, day_of_week, isChecked, existingTraining) => {
    if (isChecked) {
      await insertGroupTraining({ id_group, day_of_week });
    } else {
			if (existingTraining?.id_group_training) {
				await deleteGroupTraining({ id_group_training: existingTraining.id_group_training });
			}
    }
  };

  if (isLoadingGroups) return <div className="setting-group__loading">Chargement...</div>;

  return (
    <div className="setting-group">
      {/* <div className="setting-group__toolbar">
        <GroupHandler
          options={optionGroups}
          selectedOption={selectedGroup} setSelectedOption={setSelectedGroup}
        />
      </div> */}

      <div className="setting-group__list">
        {isSuccessGroups && groups.filter(g => g.id_group !== 20).map(group => {
          const exceptionWeeks = groupExceptionsByWeek(group.group_trainings_exceptions);

          return (
            <div key={group.id_group} className="group-card">
              {/* <div className="group-card__title">{group.lib_group}</div> */}
              <DayCheckboxRow
                variant="general"
                label="Entraînements généraux" libGroup={group.lib_group}
                getChecked={(dayValue) => group.group_trainings.some(t => t.day_of_week === dayValue)}
                onToggle={(dayValue, checked) => {
                  const existing = group.group_trainings.find(t => t.day_of_week === dayValue);
                  handleToggleGeneral(group.id_group, dayValue, checked, existing);
                }}
              />

              {exceptionWeeks.map((week, idx) => (
                <DayCheckboxRow
                  key={idx}
                  variant="exception"
                  label={week.label}
                  sublabel={`${week.date_from} → ${week.date_to}`}
                  getChecked={(dayValue) => week.days.some(d => d.day_of_week === dayValue)}
                  // pas de onToggle pour l'instant => lecture seule
                />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  )
}

export default SettingGroup